import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

const getGridTemplate = (columns: number) => css`
  grid-template-columns: repeat(${columns}, minmax(0, 1fr));
`;

export const PresetPhotoPickerGrid = styled.div<{
  $hasPadding?: boolean;
  $maxHeight?: number;
}>`
  display: grid;
  ${getGridTemplate(4)}
  gap: 10px;
  height: min-content;

  @media (max-width: 544px) {
    ${getGridTemplate(3)}
  }

  @media (max-width: 400px) {
    ${getGridTemplate(2)}
  }

  ${({ $hasPadding }) =>
    $hasPadding &&
    css`
      padding: 15px 40px 65px;

      @media (max-width: 743px) {
        padding: 15px 15px 65px;
      }
    `}

  ${({ $maxHeight }) =>
    $maxHeight &&
    css`
      max-height: ${$maxHeight}px;
      overflow-y: auto;
    `}
`;

export const PresetPhotoPickerSubtitle = styled(Typography.Caption)`
  font-size: 15px;
  padding: 10px 40px;

  @media (max-width: 743px) {
    padding: 10px 15px;
  }
`;

export const PresetPhotoPickerItem = styled.div`
  position: relative;
  aspect-ratio: 1;
`;

export const PresetPhotoPickerImage = styled.img<{ $isSelected: boolean }>`
  border-radius: 14px;
  object-fit: cover;
  cursor: pointer;
  width: 100%;
  height: 100%;

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      border: 1px solid ${({ theme }) => theme.palette.system.blue};
    `}
`;

export const PresetPhotoPickerCheckbox = styled.span<{ $isSelected: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 5px;
  position: absolute;
  top: 5px;
  right: 5px;
  box-shadow: 2px 5px 12px 0 rgba(0, 0, 0, 0.15);

  ${({ $isSelected }) =>
    !$isSelected &&
    css`
      border: 1px solid ${({ theme }) => theme.palette.primary.border};
      background: rgba(255, 255, 255, 0.5);
      box-shadow: 2px 5px 12px 0 rgba(0, 0, 0, 0.15);
    `}
`;

export const PresetPhotoPickerApply = styled.div`
  position: fixed;
  bottom: ${({ theme }) =>
    theme.isWebView ? `${+theme.insetsBottom + 15}px` : '15px'};
  width: 100%;
  padding: 0 40px;

  @media (max-width: 743px) {
    padding: 0 15px;
  }
`;

export const PresetPhotoPickerPopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 40px 50px;
`;

export const PresetPhotoPickerPopupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
`;

export const PresetPhotoPickerPopupFooter = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 20px;
`;
